import axios from 'axios';
import { API_PREFIX, SHORT_TIME_OUT } from '@/assets/js/configs';
import { createSource } from '@/assets/js/http';

export default function getBiomarkersInfo() {
  const url = `${API_PREFIX}/biomarkers`;
  return axios.get(url, {
    timeout: SHORT_TIME_OUT,
    cancelToken: (createSource()).token,
  });
}
